<div
  v-if="inline"
  class="event-survey-admin-shell card rounded-4 shadow-sm border overflow-hidden"
>
  <div class="p-4 border-bottom">
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3">
      <div class="d-flex flex-column flex-md-row align-items-start gap-3">
        <div class="d-inline-flex align-items-center justify-content-center rounded-4 text-white flex-shrink-0 bg-primary shadow-sm" >
          <i class="bi bi-clipboard2-pulse fs-5"></i>
        </div>
        <div>
          
          <h3 class="mt-3 mb-0 fs-5 fw-bolder text-dark">
            {{ is_edit_mode ? 'Editing Event Survey' : (has_survey ? 'Event Survey Dashboard' : 'Create Event Survey') }}
          </h3>
          <p class="mt-2 mb-0 text-muted small lh-lg">
            Design the attendee feedback flow, review response activity, and keep your survey crisp and useful.
          </p>
        </div>
      </div>

      <div class="d-flex flex-row gap-2 gap-sm-3 w-100">
        <div class="bg-white border rounded-5 px-3 px-sm-4 py-3 shadow-sm h-100 flex-fill">
          <span class="d-block text-uppercase text-secondary-emphasis fw-semibold small text-nowrap">Questions</span>
          <span class="d-block mt-1 fs-5 fw-bolder text-dark">{{ survey_question_total }}</span>
        </div>
        <div class="bg-white border rounded-5 px-3 px-sm-4 py-3 shadow-sm h-100 flex-fill">
          <span class="d-block text-uppercase text-secondary-emphasis fw-semibold small text-nowrap">Respondents</span>
          <span class="d-block mt-1 fs-5 fw-bolder text-dark">{{ survey_response_total }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="p-3 px-md-4 d-flex flex-column flex-md-row align-items-stretch align-items-md-center justify-content-between gap-3 border-bottom" >
    <div>
      <span v-if="has_survey" class="task-chip task-chip-status text-xxs">Survey active</span>
      <span v-else class="task-due-chip d-inline-flex align-items-center fw-500">No survey published yet</span>
    </div>
    <div class="d-flex flex-wrap gap-2">
      <button
        v-if="has_survey"
        type="button"
        class="btn btn-sm btn-light rounded border px-3 fw-bold"
        @click="open_view_survey(current_survey)"
      >
        {{ admin_view_survey ? 'Hide Results' : 'View Results' }}
      </button>
      <button
        v-if="!has_survey"
        type="button"
        class="btn btn-sm btn-primary rounded px-3 fw-bold"
        @click="open_create_survey(current_event || { id: current_event_id })"
      >
        Create survey
      </button>
      <button
        v-if="has_survey"
        type="button"
        class="btn btn-sm btn-primary rounded px-3 fw-bold"
        @click="open_edit_survey(current_survey)"
      >
        Edit survey
      </button>
      <button
        v-if="has_survey"
        type="button"
        class="btn btn-sm btn-danger rounded px-3 fw-bold"
        @click="delete_survey(current_survey.id)"
      >
        Delete
      </button>
      <button
        v-if="show_event_survey_form"
        type="button"
        class="btn btn-secondary rounded px-3 fw-bold"
        @click="show_event_survey_form = false; reset_inline_form();"
      >
        Close editor
      </button>
    </div>
  </div>

  <div v-if="inline && admin_view_survey" class="p-4" >
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-start gap-3 mb-3">
      <div>
        <div class="text-uppercase text-secondary small fw-bold">Survey performance</div>
        <h4 class="mt-1 mb-0 fw-bolder text-dark">{{ admin_view_survey?.name || 'Survey' }}</h4>
        <div v-if="admin_view_survey?.description" class="mt-2 text-muted small lh-lg" v-html="admin_view_survey.description"></div>
      </div>
      <button class="btn btn-outline-secondary btn-sm rounded px-3" type="button" @click="close_inline_survey_view">
        Hide
      </button>
    </div>

    <div class="d-grid gap-3">
      <div
        v-for="(question, index) in admin_view_survey?.survey_questions || []"
        :key="question.id"
        class="bg-white border rounded shadow-sm p-3"
      >
        <div class="d-flex justify-content-between align-items-center gap-3 mb-3">
          <span class="badge rounded text-dark bg-primary-subtle px-3 py-2">Question {{ index + 1 }}</span>
          <span class="badge rounded text-dark bg-secondary-subtle px-3 py-2">
            {{ get_question_type_label(question.question.question_type.question_type) }}
          </span>
        </div>
        <div class="fw-bold text-dark lh-base">{{ question.question.question }}</div>

        <div class="d-flex flex-wrap gap-2 mt-2">
          <span class="badge rounded text-dark bg-secondary-subtle px-3 py-2">{{ count_question_respondents(question) }} responses</span>
          <span v-if="question.question.is_mandatory" class="badge rounded text-danger bg-danger-subtle px-3 py-2">Required</span>
        </div>

        <div v-if="question.question.options?.length" class="d-flex flex-wrap gap-2 mt-3">
          <span v-for="opt in question.question.options" :key="opt.id" class="badge rounded text-dark bg-light border px-3 py-2">
            {{ opt.option }}
          </span>
        </div>

        <div v-if="question.answers?.length" class="d-flex flex-column gap-2 mt-3">
          <div
            v-for="(response, response_id) in question.answers"
            :key="response_id"
            class="bg-light rounded-4 px-3 py-2 text-muted small lh-base"
          >
            <strong v-if="response.user?.is_blocked">Unknown User</strong>
            <strong v-else>{{ response.user?.first_name }} {{ response.user?.last_name }}</strong>
            <span class="text-muted">:</span>
            {{ response.answer || '-' }}
          </div>
        </div>

        <div v-else class="text-secondary-emphasis small fst-italic mt-3">
          No responses yet.
        </div>
      </div>
    </div>
  </div>

  <div v-if="show_event_survey_form" class="p-4" >
      <form @submit.prevent="submit_survey">
        <div class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-start gap-3 mb-3">
          <div>
            <div class="text-uppercase text-secondary small fw-bold">Builder</div>
            <h4 class="mt-1 mb-0 fw-bolder text-dark">{{ survey_id ? 'Refine your survey' : 'Add your first questions' }}</h4>
          </div>
          <button type="submit" class="btn btn-primary rounded px-4">
            {{ survey_id ? 'Update Survey' : 'Create Survey' }}
          </button>
        </div>

        <div class="bg-white border rounded-4 shadow-sm p-3">
          <div class="d-flex align-items-center gap-2 fw-bold text-dark small">
            <i class="bi bi-list-check text-primary"></i>
            Add Question
          </div>
          <div class="mt-2 mb-3 text-muted small">Add one question at a time and shape the response flow before publishing.</div>

          <div v-if="show_question_form" class="row g-3">
            <div class="col-12">
              <label class="text-xxs fw-500">Question Text <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control text-xxs rounded-4 p-3 bg-white"
                v-model="new_question.text"
                placeholder="Enter your question here..."
                list="question_suggestions_inline"
                @input="on_question_input"
                @change="on_question_select"
              />
              <datalist id="question_suggestions_inline">
                <option v-for="question in filtered_questions" :key="question.id" :value="question.question"></option>
              </datalist>
            </div>

            <div class="col-12 col-md-6">
              <label class="text-xxs fw-500">Question Type <span class="text-danger">*</span></label>
              <select v-model="new_question.type" class="form-select text-xxs p-3 rounded-4">
                <option value="" disabled>Select type</option>
                <option
                  v-for="type in question_types.filter(t => t.question_type !== 'file' && t.question_type !== 'textarea')"
                  :key="type.id"
                  :value="type.id"
                >
                  {{ type.question_type }}
                </option>
              </select>
            </div>

            <div class="col-12 col-md-6">
              <label class="text-xxs fw-500">Question Number <span class="text-danger">*</span></label>
              <input
                type="text"
                class="form-control text-xxs rounded-4 p-3 bg-white"
                placeholder="Eg. 1"
                v-model="new_question.question_number"
              />
            </div>

            <div class="col-12 col-md-6">
              <label class="text-xxs fw-500">Is this question mandatory?</label>
              <select v-model="new_question.is_mandatory" class="form-select text-xxs p-3 rounded-4">
                <option :value="false">No</option>
                <option :value="true">Yes</option>
              </select>
            </div>

            <div class="col-12">
              <div
                v-if="new_question.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === new_question.type)?.question_type)"
                class="border border-primary-subtle rounded-4 p-3 bg-light bg-gradient"
              >
                <div class="fw-500 text-xxs mb-2">Options</div>

                <div
                  v-for="(option, index) in new_question.options"
                  :key="option.id || index"
                  class="d-flex align-items-center gap-2 mb-2"
                >
                  <input
                    type="text"
                    class="form-control text-xxs rounded-4 p-3 bg-white"
                    v-model="option.text"
                    placeholder="Enter option text"
                  />
                  <button
                    class="btn btn-outline-danger btn-sm rounded"
                    type="button"
                    @click="remove_option(index)"
                    title="Remove option"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </div>

                <button type="button" class="btn btn-link text-primary text-xxs px-0 text-decoration-none" @click="add_option">
                  <i class="bi bi-plus-lg me-1"></i>
                  Add Option
                </button>
              </div>
            </div>

            <div class="col-12 d-flex justify-content-end gap-2">
              <button type="button" class="btn btn-outline-secondary btn-sm rounded px-3" @click="clear_new_question">
                <i class="bi bi-trash me-1"></i>
                Clear Question
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm rounded px-3"
                @click="add_question_to_survey"
                :disabled="!new_question.text || !new_question.type || !new_question.question_number"
              >
                <i class="bi bi-plus-lg me-1"></i>
                Add Question to Survey
              </button>
            </div>
          </div>
        </div>

        <div class="mt-3" v-if="created_questions.length > 0">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="text-uppercase text-secondary small fw-bold mb-0">Question lineup</div>
            <span class="badge rounded text-secondary bg-secondary-subtle px-3 py-2">{{ created_questions.length }} questions</span>
          </div>
          <div v-for="(question, index) in created_questions" :key="index"
            class="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-3 bg-white border rounded-4 shadow-sm p-3 mb-3">
            <div>
              <span class="text-xxs fw-semibold text-dark">{{ index + 1 }}. {{ question.text }}</span>
              <span class="badge rounded text-secondary bg-secondary-subtle px-3 py-2 ms-2">
                {{ question.type ? (question_types.find(t => t.id === question.type)?.question_type || 'Unknown') : 'Unknown' }}
              </span>
              <span v-if="question.is_mandatory" class="badge rounded text-danger bg-danger-subtle px-3 py-2 ms-1">Required</span>
            </div>
            <button type="button" class="btn btn-sm text-danger" @click="remove_created_question(index)" title="Remove">
              <i class="bi bi-trash text-danger"></i>
            </button>
          </div>
        </div>
      </form>
  </div>

  <div v-else class="p-4 text-muted small lh-lg" >
    <span v-if="has_survey">Open the overview to inspect response activity, or edit the survey to adjust your questions.</span>
    <span v-else>Create a survey attendees can answer after the event.</span>
  </div>
</div>

<teleport v-else to="body">
  <div class="modal fade" id="create_survey" tabindex="-1" aria-labelledby="create_survey_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="create_survey_label">
            {{ is_edit_mode ? 'Edit Survey' : 'Create a Survey' }}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="card-body p-3 modal-body modal-body-scroll">
          <form @submit.prevent="submit_survey">
            <!-- Survey Title -->
            <div class="mb-3">
              <label for="survey_name" class="form-label text-xxs fw-500">Survey Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control rounded text-xxs" id="survey_name"
                placeholder="Enter survey name" v-model="survey_name">
              <p v-if="errors.survey_name" class="text-danger text-xxs mt-1">{{ errors.survey_name }}</p>
            </div>

            <!-- Survey Description -->
            <div class="mb-3">
              <label for="survey_description" class="form-label text-xxs fw-500">Survey Description</label>
              <QuillEditor theme="snow" v-model="survey_description" ref="quill_survey_editor_ref"
                class="quill-editor" placeholder="Enter your description here..." toolbar="half" />
            </div>
            <div class="mb-3 p-2">
              <button type="button" class="btn btn-primary btn-sm float-end text-xxs rounded shadow-sm"
                @click="show_question_form = !show_question_form">
                <i class="bi bi-plus-lg me-1"></i>
                {{ show_question_form ? 'Hide Question Form' : 'Add Question' }}
              </button>
              <div v-if="show_question_form">
                <div class="row mt-2 w-100">
                  <div class="form-group col-sm-6 mb-1 my-3">
                    <label class="text-xxs">Question <span class="text-danger">*</span></label>
                    <div class="d-flex">
                      <input type="text" class="form-control text-xxs rounded p-2 bg-white"
                        v-model="new_question.text" placeholder="Enter question text"
                        list="question_suggestions" @input="on_question_input"
                        @change="on_question_select" />
                    </div>
                    <datalist id="question_suggestions">
                      <option v-for="question in filtered_questions" :key="question.id"
                        :value="question.question"></option>
                    </datalist>
                  </div>

                  <div class="form-group col-sm-6 mb-1 my-3">
                    <label class="text-xxs">Question Number <span class="text-danger">*</span></label>
                    <input type="text" class="form-control text-xxs rounded p-2 bg-white"
                      placeholder="Eg. 1" v-model="new_question.question_number" />
                  </div>

                  <div class="form-group col-sm-6 mb-1 my-3">
                    <label class="text-xxs">Type <span class="text-danger">*</span></label>
                    <select v-model="new_question.type" class="form-select text-xxs p-2 rounded">
                      <option value="" disabled>Select</option>
                      <option
                        v-for="type in question_types.filter(t => t.question_type !== 'file' && t.question_type !== 'textarea')"
                        :key="type.id" :value="type.id">
                        {{ type.question_type }}
                      </option>
                    </select>

                    <div v-if="new_question.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === new_question.type)?.question_type)"
                      v-for="(option, index) in new_question.options" :key="option.id || index"
                      class="d-flex align-items-center mt-2 mb-2">
                      <input type="text" class="form-control text-xxs rounded p-2 me-2"
                        v-model="option.text" placeholder="Enter option text" />
                      <button class="btn btn-danger btn-sm text-xxs" type="button"
                        @click="remove_option(index)">
                        <i class="bi bi-trash"></i>
                      </button>
                    </div>

                    <div
                      v-if="new_question.type && ['multiple_choice', 'checkbox', 'selection'].includes(question_types.find(t => t.id === new_question.type)?.question_type)">
                      <button
                        class="btn btn-sm btn-warning text-white mt-3 text-xxs rounded shadow-sm fw-500"
                        type="button" @click="add_option">
                        Add Option
                      </button>
                    </div>
                  </div>

                  <div class="form-group col-sm-6 mb-1 my-3">
                    <label class="text-xxs">Is the question mandatory?</label>
                    <select v-model="new_question.is_mandatory" class="form-select text-xxs p-2 rounded">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </div>

                  <div class="col-12 mt-3">
                    <button type="button" class="btn btn-sm btn-success text-xxs rounded float-end"
                      @click="add_question_to_survey"
                      :disabled="!new_question.text || !new_question.type || !new_question.question_number">
                      Add Question to Survey
                    </button>
                  </div>
                </div>
                <div class="mt-3" v-if="created_questions.length > 0">
                  <h6 class="text-xxs fw-semibold">Created Questions</h6>
                  <div v-for="(question, index) in created_questions" :key="index"
                    class="d-flex justify-content-between align-items-center border rounded p-2 text-xxs mb-2">
                    <div>
                      <span class="text-xxs">{{ index + 1 }}. {{ question.text }}</span>
                      <span class="badge bg-secondary ms-2 text-xxs rounded">
                        {{ question.type ? (question_types.find(t => t.id ===
                        question.type)?.question_type || 'Unknown') : 'Unknown' }}
                      </span>
                      <span v-if="question.is_mandatory"
                        class="badge bg-danger ms-1 text-xxs">Required</span>
                    </div>
                    <button type="button" class="btn btn-sm text-danger"
                      @click="remove_created_question(index)" title="Remove">
                      <i class="bi bi-trash text-danger"></i>
                    </button>
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="created_questions.length > 0">
                  <button type="submit" class="btn btn-sm btn-primary text-xxs rounded">
                    {{ survey_id ? 'Update' : 'Create' }} Survey
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</teleport>

<teleport to="body">
  <div class="modal fade" id="view_survey_modal" tabindex="-1" aria-labelledby="view_survey_label" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <p class="modal-title text-center text-xxs fw-500 mb-0 w-100" id="view_survey_label">
            {{ admin_view_survey?.name || 'Survey' }}
          </p>
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
        <div class="card-body p-3 modal-body modal-body-scroll">
          <p v-if="admin_view_survey?.description" class="text-xxs text-muted mb-3" v-html="admin_view_survey.description"></p>

          <div v-for="(question, index) in admin_view_survey?.survey_questions || []" :key="question.id" class="mb-3">
            <label class="text-xs fw-bold mb-1 d-block">
              {{ index + 1 }}. {{ question.question.question }}
            </label>

            <div class="text-xxs text-muted mb-2">
              Type: {{ question.question.question_type.question_type }}
            </div>

            <div v-if="question.question.options?.length" class="d-flex flex-wrap gap-2">
              <span v-for="opt in question.question.options" :key="opt.id" class="badge bg-light text-dark text-xxs">
                {{ opt.option }}
              </span>
            </div>

            <div v-if="question.answers?.length" class="mt-2">
              <div class="text-xxs fw-semibold mb-1">Responses ({{ question.answers.length }})</div>
              <ul class="list-group list-group-flush">
                <li v-for="(response, response_id) in question.answers" :key="response_id"
                  class="list-group-item py-1 px-2 small fw-light text-xxs">
                  <i class="bi bi-dot text-secondary me-1"></i>
                  <strong v-if="response.user?.is_blocked">Unknown User</strong>
                  <strong v-else>{{ response.user?.first_name }} {{ response.user?.last_name }}</strong>
                  : {{ response.answer || '—' }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</teleport>
